<div class="iaq-off-hours-card-container" [ngStyle]="{'background-image':' url(assets/images/good_quality_air.png)'}">
  <div class="iaq-off-hours-card-text-container">
    <span class="iaq-off-hours-card-text">Air quality information will be updated during building operating hours</span>
  </div>
</div>
